require('./base/polyfill.js');
require('./components/gallery.js');
require('./components/map.js');
